import { render, staticRenderFns } from "./Page_About.vue?vue&type=template&id=1c0ffad6&scoped=true&"
import script from "./Page_About.vue?vue&type=script&lang=js&"
export * from "./Page_About.vue?vue&type=script&lang=js&"
import style0 from "./Page_About.vue?vue&type=style&index=0&id=1c0ffad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0ffad6",
  null
  
)

export default component.exports